/* EditSnapshotViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EditSnapshotViewRenderer");
//const _ = require('lodash');

class EditSnapshotViewComponent extends EventEmitter {
    constructor(state) {
        super();
        this._description = state.description;
        this._captureTime = state.captureTime;

        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        return Promise.resolve(prom).then(() => {
            this._renderer = undefined;
            this._logger = undefined;
            this._gameEditor = undefined;
            this._deviceConfigFeed = undefined;
            this._deviceConfigCollection = undefined;
            this._deviceConfigurationEntityId = undefined;
            this._deviceConfigurationEntity = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = EditSnapshotViewComponent;
EditSnapshotViewComponent.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.viewState"];
EditSnapshotViewComponent.$displayDetails = {
    type: "View",
    name: "Edit Snapshot Name",
    icon: "common.edit",
    shown: false
};
